export default __webpack_public_path__ + "../staticImages/fallback_wrapped_bps_de_de.png";